import "slick-carousel/slick/slick.min.js";

$(function(){
  $('[data-timeline-slider]').slick({
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          customPaging: function(slider, i) {return $('<button type="button" data-role="none" role="button" tabindex="0" />').html($(slider.$slides[i]).attr("data-year"));}
        }
      }
    ]
  });
});